import React from 'react';
import { connect } from 'react-redux'

import FinishedInstitutionLogins from './FinishedInstitutionLogins'
import CurrentInstitutionLogin from './CurrentInstitutionLogin'
import {loginStates} from '../constants/states'
import CustomHtmlParser from './CustomHtmlParser'
import ThemedSpinner from './ThemedSpinner'
import CardWrapper from './CardWrapper'
import TermsAndConditions from './TermsAndConditions'
import Redirect from './Redirect'
import CheckIfSubmitWinz from "./CheckIfSubmitWinz";
import PreConsentForm from './PreConsentForm';
import Consent from './Consent';
import ConsentTransfer from './ConsentTransfer';
import ConsentSuccess from './ConsentSuccess'; 
import ConsentError from './ConsentError';

import { themeType, currentLoginType, institutionType, sessionDataType } from '../initialStoreValues';

class Wizard extends React.Component {

    render() {
        //On first load show T&C "I agree" screen
        if (!this.props.sessionData.acceptedTerms) {

            return <CardWrapper classSelector="selector_TermsAndConditions">
                <TermsAndConditions 
                    theme={this.props.theme} 
                    dispatch={this.props.dispatch} 
                    settings={this.props.sessionData.clientSettings}
                    institutions={this.props.institutions} />
                </CardWrapper>
        }

        //After accepting T&Cs show institution selector
        const classSelector = "selector_" + this.props.currentLogin.state;

        switch (this.props.currentLogin.state) {
            case loginStates.LOGIN_STATE_CHECK_IF_SUBMIT_WINZ:
                return <CardWrapper classSelector={classSelector}>
                    <CheckIfSubmitWinz
                        dispatch={this.props.dispatch}
                        clientName={this.props.sessionData.clientSettings.name}
                        winzName={(this.props.institutions && this.props.institutions['winz'] && this.props.institutions['winz']['name'])?this.props.institutions['winz']['name']:'Work and Income NZ'}
                    />
                </CardWrapper>
            case loginStates.LOGIN_STATE_LOADING:         
                return <CardWrapper classSelector={classSelector}>                         
                        <div className="form-group">
                            <h2 className="d-flex justify-content-center spinner-titile">{this.props.institution.name}</h2>
                        </div>                                    
                        <ThemedSpinner theme={this.props.theme} />
                    </CardWrapper>            
            case loginStates.LOGIN_STATE_FINISHED:
                return <CardWrapper classSelector={classSelector}>
                        <FinishedInstitutionLogins withPicker={false} />
                    </CardWrapper>
            case loginStates.LOGIN_STATE_INSTITUTIONS_PICKER:
                return <CardWrapper classSelector={classSelector}>
                        <FinishedInstitutionLogins withPicker={true} />
                    </CardWrapper>
            case loginStates.LOGIN_STATE_SUBMIT_ALL_LOADING:
                return <CardWrapper classSelector={classSelector}>
                        <div className="form-group">
                            <h2 className="d-flex justify-content-center spinner-titile">{this.props.theme.text.submitAllLoadingText}</h2>
                        </div>
                        <ThemedSpinner theme={this.props.theme} />
                    </CardWrapper>
            case loginStates.LOGIN_STATE_ALL_FINISHED:
                if(this.props.session.redirectUrl){
                    return <CardWrapper>
                        <Redirect />                                   
                    </CardWrapper>
                }else{
                    return <CustomHtmlParser data={this.props.theme.completedScreen} />
                }
            case loginStates.LOGIN_STATE_PRECONSENT_LOADER:
                return <CardWrapper classSelector={classSelector}>                         
                        <div className={`form-group ${!this.props.currentLogin.title ? 'hide' : ''}`}>
                            <h2 className="d-flex justify-content-center spinner-titile">{this.props.currentLogin.title}</h2>
                        </div>                                    
                        <ThemedSpinner theme={this.props.theme} />
                    </CardWrapper>
            case loginStates.LOGIN_STATE_PRECONSENT_FORM:                
                return <CardWrapper classSelector={classSelector}>
                    <PreConsentForm 
                        jsonData={this.props.currentLogin.form} 
                        theme={this.props.theme}
                        dispatch={this.props.dispatch}
                        slug={this.props.currentLogin.slug}
                        preConsentFormData={this.props.sessionData.preConsentFormData}
                        />
                </CardWrapper>
            case loginStates.LOGIN_STATE_CONSENT_LOAD:
                return <CardWrapper classSelector={classSelector}>
                    <Consent 
                        consentData={this.props.currentLogin.consent} 
                        theme={this.props.theme}
                        dispatch={this.props.dispatch}
                        slug={this.props.currentLogin.slug}
                        />
                </CardWrapper>
            case loginStates.LOGIN_STATE_CONSENT_INITIALISED:
                return <CardWrapper classSelector={classSelector}>
                    <ConsentTransfer
                        theme={this.props.theme}
                        dispatch={this.props.dispatch}
                        institution={this.props.institution}
                        redirect_url={this.props.currentLogin.redirect_url} 
                        consent_guid={this.props.currentLogin.consent_guid} 
                        />
                </CardWrapper>
            case loginStates.LOGIN_STATE_CONSENT_SUCCESS:
                return <CardWrapper classSelector={classSelector}>
                    <ConsentSuccess
                        theme={this.props.theme}
                        dispatch={this.props.dispatch}
                        institution={this.props.institution}
                        consent_guid={this.props.currentLogin.consent_guid} 
                        />
                </CardWrapper>
            case loginStates.LOGIN_STATE_CONSENT_ERROR:
                return <CardWrapper classSelector={classSelector}>
                    <ConsentError
                        theme={this.props.theme}
                        dispatch={this.props.dispatch}
                        institution={this.props.institution}
                        />
                </CardWrapper>
            default:
                return <CardWrapper classSelector={classSelector}>
                    {this.props.institution ? <CurrentInstitutionLogin /> : <ThemedSpinner theme={this.props.theme} />}
                    </CardWrapper>
        }      
    }
}

Wizard.propTypes = {
    theme : themeType,
    currentLogin: currentLoginType,
    institution: institutionType,
    sessionData: sessionDataType
}

const mapStateToProps = (state) => {
    return {
        theme : state.common.theme,
        session: state.session,
        currentLogin: state.currentLogin,
        institution: state.institutions.byslug[state.currentLogin.slug],
        sessionData: state.sessionData,
        institutions:state.institutions.byslug
    }
}

export default connect(mapStateToProps)(Wizard);
